module.exports = __webpack_public_path__ + "static/media/valor2.43978064.png";